import { getListCountryService } from "./country.service";

async function getListCountry(services) {
    try {
        return await services()
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log("error on controller country : ", error)
    }
}

export const countryController =  getListCountry(getListCountryService)
